import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { HuangHeiDaoInfo } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'HourDaoPathComponent',
  props: {
    huangHeiDaoInfo: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["px-2 py-0.5 rounded text-[11px] font-bold", 
      __props.huangHeiDaoInfo.path_type === 'HuangDao'
        ? 'bg-[#EAF7EE] text-success'
        : 'bg-secondary text-alternative-gray'
    ])
  }, _toDisplayString(__props.huangHeiDaoInfo.name) + " " + _toDisplayString(_ctx.$t(
        __props.huangHeiDaoInfo.path_type === "HuangDao"
          ? "calculators.personal-date.full-day-report.hourlyTable.huangDao"
          : "calculators.personal-date.full-day-report.hourlyTable.heiDao"
      )), 3))
}
}

})